module.exports = __webpack_public_path__ + "img/config3.1aa0f309.png";